import classnames from 'classnames'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const Modal = props => {
  const modalClose = (event, reason) => {
    event.preventDefault()

    if (props.disableBackdrop && reason === 'backdropClick')
      return

    props.handleClose()
  }
  return (
    <BootstrapDialog
      className={classnames('modal', props.className)}
      maxWidth={props.maxWidth}
      onClose={modalClose}
      open={props.open}>
      <DialogTitle sx={{m: 0, p: 2}} id='customized-dialog-title'>
        {props.title}
      </DialogTitle>
      <DialogContent dividers>
        {
          props.subHeading && (
            <Typography gutterBottom>{props.subHeading}</Typography>
          )
        }
        {props.children}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.handleClose}>
          {props.buttonText}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}

Modal.propTypes = {
  buttonText: PropTypes.string.isRequired,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  subHeading: PropTypes.string,
  body: PropTypes.string,
  title: PropTypes.string.isRequired,
  maxWidth: PropTypes.string.isRequired
}

export default Modal
